angular
  .module('ui-ng-calendar')
  .controller('phxCalendarColorKeyFullController', function () {
    return;
  })
  .component('phxCalendarColorKeyFull', {
    templateUrl: 'ui-ng-calendar/src/views/calendar_color_key_full/calendar_color_key_full.html',
    controller: 'phxCalendarColorKeyFullController'
  });



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/views/calendar_color_key_full/calendar_color_key_full_component.ts